import createAction from './';
import { remoteVideoConnected } from '../selectors/connectionStatus';
import { conferenceStopping } from '../selectors/consultationInfo';

export const SET_CONSULTATION_ESTABLISHED = createAction('SET_CONSULTATION_ESTABLISHED');
export const SET_RECONNECTION_STATUS = createAction('SET_RECONNECTION_STATUS');
export const UNSET_RECONNECTION_STATUS = createAction('UNSET_RECONNECTION_STATUS');

export const checkConnectionEstablished = () => (dispatch, getState) =>
  (remoteVideoConnected(getState())) && dispatch({ type: SET_CONSULTATION_ESTABLISHED });

export const checkReconnectionStatus = () => (dispatch, getState) => {
  const state = getState();
  const time = new Date();
  const { consultationEstablishedAtLeastOneTime, reconnection } = state.conference.consultationLifecycle;

  if (!remoteVideoConnected(state) && !conferenceStopping(state) &&
    consultationEstablishedAtLeastOneTime && !reconnection) {

    return dispatch({
      type: SET_RECONNECTION_STATUS,
      meta: { time },
    });
  }

  if (remoteVideoConnected(state) && reconnection) {
    return dispatch({ type: UNSET_RECONNECTION_STATUS });
  }
};

export const setReconnectionStatus = () => dispatch => {
  const time = new Date();

  return dispatch({
    type: SET_RECONNECTION_STATUS,
    meta: { time },
  });
};
